import CustomCheckbox from "components/Atoms/CustomCheckbox"
import CustomTag from "components/Atoms/CustomTag"
import CustomTooltip from "components/Atoms/CustomTooltip"
import {
  Content,
  ProgressStep,
  ProgressStepsWrapper,
  Title,
} from "components/Molecules/ProgressSteps"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import relativeTime from "dayjs/plugin/relativeTime"
import React from "react"
import classNames from "utils/classNames"
dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)

function SubStep({ checked, minimal, time, className, intent, children }) {
  return (
    <div className={classNames("flex justify-start items-baseline", className)}>
      <CustomCheckbox intent="success" checked={checked} />
      <span className="mx-2">{children}</span>
      {time && (
        <CustomTag intent={intent} minimal={minimal}>
          {time}
        </CustomTag>
      )}
    </div>
  )
}
function Time({ timestamp }) {
  return (
    <>
      {timestamp ? (
        <CustomTooltip
          content={dayjs(timestamp).format("dddd, Do MMMM YYYY, h:mm:ss a")}
        >
          {dayjs(timestamp).format("h:mm a")}
        </CustomTooltip>
      ) : (
        "NA"
      )}
    </>
  )
}
const FrontEndProgress = ({
  source,
  destination,
  start,
  end,
  startRoot,
  startSub,
  endRoot,
  endSub,
  mid,
  isEcom,
  bookings,
}) => {
  return (
    <>
      <ProgressStepsWrapper className="vt-trip-progress" vertical={true}>
        <ProgressStep
          done={start?.every(s => s.timestamp)}
          intent={startRoot?.timestamp ? "success" : "none"}
        >
          <Title>
            {startRoot?.name}{" "}
            <span className="vt-muted">| {source?.name ?? "NA"}</span>
            <CustomTag intent="success" minimal className="ml-2">
              <Time timestamp={startRoot?.timestamp} />
            </CustomTag>
          </Title>
          <Content className="my-4">
            {startSub?.map(step => {
              return (
                <SubStep
                  minimal={true}
                  intent="success"
                  key={step?.stepId}
                  checked={step?.timestamp ? true : false}
                  time={step?.timestamp && <Time timestamp={step?.timestamp} />}
                >
                  {step?.name}
                </SubStep>
              )
            })}
          </Content>
        </ProgressStep>
        {mid?.map((steps, index) => {
          const bookingId = isEcom
            ? steps?.[0]?.bookingObj?.order?.id
            : steps?.[0]?.booking
          const booking = bookings?.find(b => b.id === bookingId)

          let address, entityName
          if (isEcom) {
            entityName = booking?.user?.fullName
            address = booking?.shippingAddress
          } else {
            const schedule = booking?.schedule
            address = schedule?.plot?.address
            entityName = schedule?.plotCommodity?.name
          }
          return (
            <ProgressStep
              key={`step-${index}`}
              done={steps?.every(s => s?.timestamp)}
              intent={steps?.some(step => step.timestamp) ? "success" : "none"}
              lineStyle={
                steps?.every(step => step.timestamp) ? "none" : "dashed"
              }
            >
              <Title>
                <span>
                  <span>{index + 1 ?? 1}. </span>
                  {entityName}
                  <br />
                  <span className="text-sm vt-muted">
                    {address?.village}, {address?.taluka}
                  </span>
                </span>
              </Title>
              <Content className="my-3">
                {steps?.map?.(step => {
                  return (
                    <SubStep
                      minimal={true}
                      intent="success"
                      key={step.stepId}
                      checked={step?.timestamp ? true : false}
                      time={
                        step?.timestamp && <Time timestamp={step?.timestamp} />
                      }
                    >
                      {step?.name}
                    </SubStep>
                  )
                })}
              </Content>
            </ProgressStep>
          )
        })}

        <ProgressStep
          done={end?.every?.(step => step?.timestamp)}
          intent={endRoot?.timestamp ? "success" : "none"}
        >
          <Title>
            {endRoot?.name}{" "}
            <span className="vt-muted">| {destination?.name ?? "NA"}</span>
            <CustomTag intent="success" minimal className="ml-2">
              <Time timestamp={endRoot?.timestamp} />
            </CustomTag>
          </Title>
          <Content className="my-4">
            {endSub?.map(step => {
              return (
                <SubStep
                  minimal={true}
                  intent="success"
                  key={step?.stepId}
                  checked={step?.timestamp ? true : false}
                  time={step?.timestamp && <Time timestamp={step?.timestamp} />}
                >
                  {step?.name}
                </SubStep>
              )
            })}
          </Content>
        </ProgressStep>
      </ProgressStepsWrapper>
    </>
  )
}

export default FrontEndProgress
